import { StyledLink, Box, Divider } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

import { OptionValuePropType } from "src/custom-prop-types/search";

import TeamListItem from "src/components/Team/TeamListItem";

import Placeholder from "./sub-components/Placeholder";
import { EVENT_TRACKING } from "src/consts/eventTracking";
import { trackExploreJourneyEvent } from "src/services/exploreOrganisationAnalytics";

const CustomStyledLink = styled(StyledLink)`
  &:hover {
    text-decoration: none;
  }
`;

const OptionBadge = ({
  data,
  isLoading,
  theme,
  groupTypes,
  workspace,
  selectedString,
  preventNavigation = false,
}) => {
  if (isLoading) {
    return (
      <>
        <Box px="s" py="s">
          <Placeholder theme={theme} />
        </Box>
        <Divider light />
      </>
    );
  }

  const { group, link } = data;

  const content = (
    <Box px="s">
      <TeamListItem
        isLastItem={data.customStyles}
        group={group}
        loading={isLoading}
        groupTypes={groupTypes}
        theme={theme}
        showInPage={true}
        workspace={workspace}
        selectedString={selectedString}
      />
    </Box>
  );

  if (preventNavigation) {
    return <Box data-testid="cp-option-link">{content}</Box>;
  }

  return (
    <CustomStyledLink
      data-testid="cp-option-link"
      to={link}
      display="block"
      width="100%"
      onClick={() => {
        trackExploreJourneyEvent(EVENT_TRACKING.SEARCH_RESULT_COMPLETED, {
          lifecycle_stage: "completed",
          entry_point: "global_search",
          operation_intent: "search",
          result_type: "team",
        });
      }}
    >
      {content}
    </CustomStyledLink>
  );
};

OptionBadge.propTypes = {
  data: OptionValuePropType,
  isLoading: PropTypes.bool,
  theme: PropTypes.string,
  groupTypes: PropTypes.object,
  workspace: PropTypes.object,
  selectedString: PropTypes.string,
  preventNavigation: PropTypes.bool,
};

export default OptionBadge;
